import { useSearchParams } from 'react-router-dom';

export const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getParam = key => searchParams.get(key);

  const setParam = (key, value) => {
    searchParams.set(key, value);
    setSearchParams(searchParams);
  };

  return { getParam, setParam };
};
